export default __webpack_public_path__ + "static/media/td.caa2b373.svg";